<template>
    <div class="title">
        <IconBase
            class="icon"
            :iconName="iconName"
            :iconColor="iconColor"
            display="flex"
            width="14"
            height="24"
        />
        <span :class="[bold ? 'font-4' : 'font-5']">
            {{ title }}
        </span>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';

export default {
    name: 'AdUnitTitle',
    components: { IconBase },
    props: {
        adUnit: {
            type: String,
            required: true,
            validator: (val) => Object.keys(consts.ADUNIT_TO_NAME).includes(val)
        },
        iconColor: {
            type: String,
            default: consts.COLORS.LIGHT_600
        },
        bold: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        iconName() {
            return `${this.adUnit}Icon`;
        },
        title() {
            return consts.ADUNIT_TO_NAME[this.adUnit];
        },
        consts: () => consts
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.title {
    display: flex;
    align-items: center;
    .icon {
        margin-top: -1px;
        margin-right: 9px;
    }
}
</style>
